import React from "react";
import Cookies from "js-cookie";
import * as Styled from "./Style";
import * as GlobalStyle from "../../CSSStyles";

const Accordion = (props) => {
  let tabIcon = "";
  if (props.accordionId == "accordionBag") {
    tabIcon = "bag-icon";
  } else if (props.accordionId == "accordionEmail") {
    tabIcon = "email-icon";
  } else if (props.accordionId == "accordionShipping") {
    tabIcon = "shipping-icon";
  } else if (props.accordionId == "accordionPayment") {
    tabIcon = "payment-icon";
  } else tabIcon = "";
  return (
    <Styled.AccordionStyle
      className={
        (props.toggle ? "accordion-open " + props.classes : props.classes) +
        " " +
        // props.customerIsLoggedIn != 1 ||
        ((props.customerIsGuest == 1 && props.customerIsGuest) ||
        Cookies.get("KK_IS_GUEST") == 1 ||
        !props.isUserRegistered ||
        props.isGuestRegisterSuccess
          ? "notSignedIn"
          : "signedIn")
      }
      ref={props.thisRef}
    >
      <div className="tab">
        <span
          id={props.accordionId}
          onClick={
            props.accordionId == "accordionBag" ||
            props.accordionId == "accordionDelivery" ||
            props.accordionId == "accordionBilling"
              ? null
              : props.changed
          }
          className={props.accordionId + " tab-label"}
        >
          <div className="tab-title sub-section-title">
            {props.accordionId == "accordionBilling" ||
            props.accordionId == "accordionDelivery" ? (
              ""
            ) : (
              <span className={"tab-icon " + tabIcon}></span>
            )}
            {props.accordionId == "accordionBilling" ||
            props.accordionId == "accordionDelivery"
              ? ""
              : props.tabName}
            {props.accordionId == "accordionShipping" ? (
              <a
                href="/shopping-help/delivery-and-returns/"
                className="delivery-charges-link"
                target="_blank"
              >
                About delivery charges
              </a>
            ) : (
              ""
            )}
          </div>
          {props.accordionId == "accordionBag" ? (
            <div className="accordion-view-wrapper">
              <div className="accordion-view-mid">
                {props.itemCount != undefined ? (
                  <span className="tab-title preview-count">
                    {props.itemCount == 1
                      ? +props.itemCount + " item"
                      : props.itemCount > 1
                      ? +props.itemCount + " items"
                      : props.itemCount == 0
                      ? ""
                      : ""}
                  </span>
                ) : null}
                <div>
                  {/* bag items preview */}
                  <div className="bag-preview-wrapper">
                    {props.data.isConfirmApiLoaded ? (
                      // Confirm API loaded
                      <div>
                        {/* ------------------------------ Available preview ------------------------------ */}
                        {props.data.confirmAvailable &&
                        props.data.confirmAvailable.length ? (
                          <div>
                            {props.data.confirmAvailable
                              .slice(0, props.availablePreviewCount)
                              .map((item, index) => (
                                <div className="bag-preview" key={item.isbn}>
                                  <div className="left">
                                    <div className="title">{item.title}</div>
                                    <div className="type">{item.type}</div>
                                  </div>
                                  <div className="right">
                                    <div
                                      className={
                                        "totalPrice " +
                                        (item.totalAfterDiscount
                                          ? "discounted-preview"
                                          : "")
                                      }
                                    >
                                      <span className="preview-slashed">
                                        {item.totalAfterDiscount
                                          ? props.currency +
                                            "" +
                                            item.totalPrice
                                          : ""}
                                      </span>
                                      {props.currency}

                                      {item.totalAfterDiscount ||
                                        (
                                          Math.round(
                                            parseFloat(
                                              item.totalPrice
                                                .toString()
                                                .replace(/,/g, "")
                                            ) * 100
                                          ) / 100
                                        ).toFixed(2)}
                                    </div>
                                    <div className="quantity">
                                      Qty: {item.quantity}
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        ) : (
                          ""
                        )}
                        {props.data.availableCount -
                          props.availablePreviewCount !=
                        0 ? (
                          props.data.availableCount -
                            props.availablePreviewCount >=
                          1 ? ( //if total item is more than previewed, show "+n more items"
                            <button
                              className="show-more"
                              onClick={props.changed}
                            >
                              +
                              {props.data.availableCount -
                                props.availablePreviewCount}{" "}
                              {props.data.availableCount -
                                props.availablePreviewCount ==
                              1
                                ? "more item"
                                : "more items"}
                              <br /> <br />
                            </button>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}

                        {/* ------------------------------ Preorder preview ------------------------------ */}
                        {props.data.confirmPreorderPartial &&
                        props.data.confirmPreorderPartial.length ? (
                          <div>
                            {props.preorderPreviewCount > 0 ? (
                              <div className="bag-type-wrapper">
                                <span className="bag-type pre-order">
                                  Pre-order
                                </span>
                                <span className="sub-text">
                                  You will be charged when the item is despatched.
                                </span>
                              </div>
                            ) : (
                              ""
                            )}

                            {props.data.confirmPreorderPartial
                              .slice(0, props.preorderPreviewCount)
                              .map((item, index) => (
                                <div className="bag-preview" key={item.isbn}>
                                  <div className="left">
                                    <div className="title">{item.title}</div>
                                    <div className="type">{item.type}</div>
                                  </div>
                                  <div className="right">
                                    <div
                                      className={
                                        "totalPrice " +
                                        (item.totalAfterDiscount
                                          ? "discounted-preview"
                                          : "")
                                      }
                                    >
                                      <span className="preview-slashed">
                                        {item.totalAfterDiscount
                                          ? props.currency +
                                            "" +
                                            item.totalPrice
                                          : ""}
                                      </span>
                                      {props.currency}

                                      {item.totalAfterDiscount ||
                                        (
                                          Math.round(
                                            parseFloat(
                                              item.totalPrice
                                                .toString()
                                                .replace(/,/g, "")
                                            ) * 100
                                          ) / 100
                                        ).toFixed(2)}
                                    </div>
                                    <div className="quantity">
                                      Qty: {item.quantity}
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        ) : (
                          ""
                        )}
                        {props.data.preorderCount -
                          props.preorderPreviewCount !=
                        0 ? (
                          props.data.preorderCount -
                            props.preorderPreviewCount >=
                          1 ? ( //if total item is more than previewed, show "+n more items"
                            <button
                              className="show-more"
                              onClick={props.changed}
                            >
                              +
                              {props.data.preorderCount -
                                props.preorderPreviewCount}{" "}
                              {props.data.preorderCount -
                                props.preorderPreviewCount ==
                              1
                                ? "more item"
                                : "more items"}
                              <br /> <br />
                            </button>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}

                        {/* ------------------------------ Unavailable preview ------------------------------ */}
                        {props.data.confirmUnavailable &&
                        props.data.confirmUnavailable.length ? (
                          <div>
                            {props.unavailablePreviewCount > 0 ? (
                              <div className="bag-type-wrapper">
                                <span className="bag-type unavailable">
                                  Unavailable
                                </span>
                                <span className="sub-text">
                                  This item is not currently available, and has
                                  not been included in your total.
                                </span>
                              </div>
                            ) : (
                              ""
                            )}

                            {props.data.confirmUnavailable
                              .slice(0, props.unavailablePreviewCount)
                              .map((item, index) => (
                                <div className="bag-preview" key={item.isbn}>
                                  <div className="left">
                                    <div className="title">{item.title}</div>
                                    <div className="type">{item.type}</div>
                                  </div>
                                  <div className="right">
                                    <div
                                      className={
                                        "totalPrice " +
                                        (item.totalAfterDiscount
                                          ? "discounted-preview"
                                          : "")
                                      }
                                    >
                                      <span className="preview-slashed">
                                        {item.totalAfterDiscount
                                          ? props.currency +
                                            "" +
                                            item.totalPrice
                                          : ""}
                                      </span>
                                      {props.currency}

                                      {item.totalAfterDiscount ||
                                        (
                                          Math.round(
                                            parseFloat(
                                              item.totalPrice
                                                .toString()
                                                .replace(/,/g, "")
                                            ) * 100
                                          ) / 100
                                        ).toFixed(2)}
                                    </div>
                                    <div className="quantity">
                                      Qty: {item.quantity}
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        ) : (
                          ""
                        )}

                        {props.data.unavailableCount -
                          props.unavailablePreviewCount !=
                        0 ? (
                          props.data.unavailableCount -
                            props.unavailablePreviewCount >=
                          1 ? ( //if total item is more than previewed, show "+n more items"
                            <button
                              className="show-more"
                              onClick={props.changed}
                            >
                              +
                              {props.data.unavailableCount -
                                props.unavailablePreviewCount}{" "}
                              {props.data.unavailableCount -
                                props.unavailablePreviewCount ==
                              1
                                ? "more item"
                                : "more items"}
                              <br /> <br />
                            </button>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      // Confirm API not loaded
                      <div>
                        {/* Bag preview */}
                        {props.availableBag && props.availableBag.length ? (
                          <div>
                            {props.availableBag
                              .slice(0, 3)
                              .map((item, index) => (
                                <div className="bag-preview" key={item.isbn}>
                                  <div className="left">
                                    <div className="title">{item.title}</div>
                                    <div className="type">{item.type}</div>
                                  </div>
                                  <div className="right">
                                    <div
                                      className={
                                        "totalPrice " +
                                        (props.discountCode ==
                                          "ALERTSDISCOUNT" ||
                                        item.discountedPrice > 0
                                          ? "discounted-preview"
                                          : "")
                                      }
                                    >
                                      {props.discountCode == "ALERTSDISCOUNT" ||
                                      item.discountedPrice > 0 ? (
                                        <span className="preview-slashed">
                                          {props.discountCode
                                            ? props.currency +
                                              "" +
                                              (
                                                Math.round(
                                                  parseFloat(
                                                    item.price
                                                      .toString()
                                                      .replace(/,/g, "")
                                                  ) *
                                                    parseFloat(
                                                      item.quantity
                                                        .toString()
                                                        .replace(/,/g, "")
                                                    ) *
                                                    100
                                                ) / 100
                                              ).toFixed(2)
                                            : ""}
                                        </span>
                                      ) : null}

                                      {props.currency}

                                      {props.discountCode.toUpperCase() ==
                                      "ALERTSDISCOUNT"
                                        ? (
                                            Math.round(
                                              parseFloat(
                                                item.totalPrice
                                                  .toString()
                                                  .replace(/,/g, "")
                                              ) *
                                                (1 - 0.2) *
                                                100
                                            ) / 100
                                          ).toFixed(2)
                                        : (
                                            Math.round(
                                              parseFloat(
                                                item.totalPrice
                                                  .toString()
                                                  .replace(/,/g, "")
                                              ) * 100
                                            ) / 100
                                          ).toFixed(2)}
                                    </div>
                                    <div className="quantity">
                                      Qty: {item.quantity}
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        ) : (
                          ""
                        )}
                        {props.availableBag.length > 3 ? (
                          <button className="show-more" onClick={props.changed}>
                            +{props.availableBag.length - 3}{" "}
                            {props.availableBag.length - 3 == 1
                              ? "more item"
                              : "more items"}
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <button
                className="accordion-view-right show-bag"
                title="Open bag"
                onClick={props.changed}
              >
                {!props.toggle ? "Edit bag" : "Hide bag"}

                <span
                  className={"toggle-bag " + (props.toggle ? "opened" : "")}
                ></span>
              </button>
            </div>
          ) : (
            ""
          )}

          {props.accordionId == "accordionEmail" ? (
            <div className="accordion-view-wrapper">
              <div>
                <div className="accordion-view">
                  {
                    // props.customerIsLoggedIn != 1 ||
                    Cookies.get("KK_IS_GUEST") == 1 || //if kk_is_guest is 1
                    (props.customerIsGuest && props.customerIsGuest == 1) ||
                    !props.isUserRegistered || //if kk_customer_id is less than 0
                    props.isGuestRegisterSuccess ? ( //if guest successfully added an email
                      // display email section on Your Details
                      <Styled.DisplayAddressStyle>
                        <p className="accordion-view-title subsub-section-title label-text-top">
                          Please enter your email address
                        </p>
                        <div className="accordion-view-text">
                          <GlobalStyle.AddressItemStyle className="input-wrapper">
                            <input
                              type="email"
                              id="guestEmail"
                              className={
                                props.guestEmailHasValue +
                                " " +
                                (props.guestEmail ? "hasValue" : "") +
                                " guest-email-input "
                              }
                              onChange={props.guestEmailChangedHandler}
                              onBlur={props.guestEmailBlurHandler}
                              autoComplete="no"
                              // value={props.guestEmail}
                              // defaultValue={props.guestEmail}
                              defaultValue={
                                Cookies.get("KK_SESSION_ID")
                                  ? Cookies.get("kkUserEmail")
                                  : ""
                              }
                              ref={props.guestEmailRef}
                              onKeyPress={props.onKeyPress}
                            />
                            <label htmlFor="guestEmail">Email address</label>

                            {props.guestEmailError ? (
                              <span className="error">
                                {props.guestEmailError}
                              </span>
                            ) : (
                              ""
                            )}

                            <p className="label-text-bottom">
                              Already have an account?{" "}
                              <a
                                href={props.signinAndCheckoutLink}
                                onClick={props.confirmRedirect}
                              >
                                Sign in
                              </a>
                            </p>
                            {props.isGuestRegisterSuccess ? (
                              <span className="success-icon"></span>
                            ) : (
                              ""
                            )}
                          </GlobalStyle.AddressItemStyle>
                        </div>
                      </Styled.DisplayAddressStyle>
                    ) : (
                      ""
                    )
                  }
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          {props.accordionId == "accordionDelivery" ? (
            <div className="accordion-view-wrapper">
              <div>
                <div className="accordion-view">
                  <Styled.DisplayAddressStyle>
                    <p className="accordion-view-title subsub-section-title">
                      Delivery Address
                    </p>
                    {props.data.confirmApiLoader || props.data.bagLoader ? 'Loading...':
                    !props.chosenDeliveryAddressID ? (
                      props.children
                    ) : (
                      <div>
                        <div className="accordion-view-text">
                          <p>
                            {props.chosenDeliveryAddressFirstName +
                              " " +
                              props.chosenDeliveryAddressLastName}
                            {}
                          </p>
                        </div>
                        <div
                          className="accordion-view-text"
                          style={{ width: "80%" }}
                        >
                          <p>
                            {props.chosenDeliveryAddressLine1}
                            {props.chosenDeliveryAddressLine2
                              ? " " + props.chosenDeliveryAddressLine2
                              : ""}
                            {", " + props.chosenDeliveryAddressCity}
                            {", " + props.chosenDeliveryAddressState}
                            {", "}
                            <span
                              style={{
                                display: "inline-block",
                                verticalAlign: "baseline",
                              }}
                            >
                              {props.chosenDeliveryAddressPostCode}
                            </span>
                            {" " + props.chosenDeliveryAddressCountryName}
                          </p>
                        </div>
                      </div>
                    )}
                  </Styled.DisplayAddressStyle>
                </div>
                {props.data.confirmApiLoader || props.data.bagLoader ? '':
                props.chosenDeliveryAddressID ? (
                  !props.toggle ? (
                    <button
                      className="accordion-view-right toggle-edit"
                      title="Open delivery address tab"
                      onClick={props.changed}
                    ></button>
                  ) : (
                    <button
                      className="accordion-view-right toggle-close"
                      title="Close delivery address tab"
                      onClick={props.changed}
                      aria-label="Close"
                    ></button>
                  )
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            ""
          )}
          {props.accordionId == "accordionBilling" ? (
            <div className="accordion-view-wrapper">
              <div>
                <div className="accordion-view">
                  <Styled.DisplayAddressStyle>
                    <p className="accordion-view-title subsub-section-title">
                      Billing Address
                    </p>
                  {props.data.confirmApiLoader || props.data.bagLoader ? 'Loading...':
                    !props.chosenBillingAddressID ? (
                      // props.children
                      ""
                    ) : props.isSameAsDelivery ? (
                      ""
                    ) : (
                      // If delivery and billing is different, display selected billing
                      <div>
                        <div className="accordion-view-text">
                          <p>
                            {props.chosenBillingAddressFirstName +
                              " " +
                              props.chosenBillingAddressLastName}
                          </p>
                        </div>
                        <div
                          className="accordion-view-text"
                          style={{ width: "80%" }}
                        >
                          <p>
                            {props.chosenBillingAddressLine1}
                            {props.chosenBillingAddressLine2
                              ? " " + props.chosenBillingAddressLine2
                              : ""}
                            {", " + props.chosenBillingAddressCity}
                            {", " + props.chosenBillingAddressState}
                            {", "}
                            <span
                              style={{
                                display: "inline-block",
                                verticalAlign: "baseline",
                              }}
                            >
                              {props.chosenBillingAddressPostCode}
                            </span>
                            {" " + props.chosenBillingAddressCountryName}
                          </p>
                        </div>
                      </div>
                    )}
                  </Styled.DisplayAddressStyle>
                </div>
                {props.data.confirmApiLoader || props.data.bagLoader ? '' :
                props.data.confirmAddressSummary && props.data.confirmAddressSummary.length <= 1 ? '' :
                props.chosenBillingAddressID?
                <button
                  className={`accordion-view-right toggle-${props.data.isBillingOptionsOpen ? 'close' : 'edit'}`}
                    // className="accordion-view-right  toggle-edit"
                    title={`${props.data.isBillingOptionsOpen ? 'Close' : 'Open'} billing address tab`}
                    // title="Open billing address tab"
                    onClick={props.changed}
                ></button>
                :''}
              </div>
            </div>
          ) : (
            ""
          )}
          {props.accordionId == "accordionShipping" ? (
            <div className="accordion-view-wrapper">
              {props.data.confirmApiLoader || props.data.bagLoader ? 'Loading...':
                props.orderSummaryShipping > 0 ? (
                props.shippingTotal ? (
                  <div>
                    <div className="accordion-view-mid">
                      <Styled.DisplayAddressStyle>
                        <p className="accordion-view-title subsub-section-title">
                          {props.shippingType}
                        </p>
                        <div className="accordion-view-text">
                          ({props.currency}
                          {props.shippingPrice.toFixed(2)} + {props.currency}
                          {props.shippingPerItem.toFixed(2)} per item)
                        </div>
                        <div>{props.shippingDeliverBy}</div>
                      </Styled.DisplayAddressStyle>
                    </div>
                    <span className="accordion-view-right shippingPrice-wrapper">
                      <p className="shippingPrice">
                        {props.currency}
                        {props.shippingTotal.toFixed(2)}
                      </p>
                    </span>
                  </div>
                ) : (
                  <div>
                    <div className="accordion-view-mid">
                      <Styled.DisplayAddressStyle>
                        <p className="accordion-view-title subsub-section-title">
                          -
                        </p>
                      </Styled.DisplayAddressStyle>
                    </div>
                    <span className="accordion-view-right shippingPrice-wrapper">
                      <p className="shippingPrice">-</p>
                    </span>
                  </div>
                )
              ) : props.orderSummaryShipping == 0 ? (
                <div>
                  <div className="accordion-view-mid">
                    <Styled.DisplayAddressStyle>
                      <p className="accordion-view-title subsub-section-title">
                        Free Delivery
                      </p>
                      <div className="accordion-view-text"></div>
                      <div>{props.shippingDeliverBy}</div>
                    </Styled.DisplayAddressStyle>
                  </div>
                  <span className="accordion-view-right shippingPrice-wrapper">
                    <p className="shippingPrice"></p>
                  </span>
                </div>
              ) : (
                <div>
                  <div className="accordion-view-mid">
                    <Styled.DisplayAddressStyle>
                      <p
                        className="accordion-view-title subsub-section-title"
                        style={{ fontSize: "1.6rem", fontWeight: "400" }}
                      >
                        Please add address for delivery options
                      </p>
                      <div className="accordion-view-text"></div>
                      <div></div>
                    </Styled.DisplayAddressStyle>
                  </div>
                  <span className="accordion-view-right shippingPrice-wrapper">
                    <p className="shippingPrice"></p>
                  </span>
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </span>
        <div className="tab-content-wrapper">
          <div className="spacer"></div>
          <div className="tab-content">
            {props.toggle ? props.children : ""}
          </div>
        </div>
      </div>
    </Styled.AccordionStyle>
  );
};

export default Accordion;
